<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';
  
  import { datepicker } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';

  export default {
    components: { datepicker, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          idRubrica: '',
          idSubrubrica: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
        },
        projetos: [],
        relatorio: [],
        saldoAnterior: 0,
        projeto: null,
        configuracao: this.$storage.configuracao(),
        dataInicio: '',
        dataFim: '',
        rubricas: [],
        subrubricas: [],
        indice: null,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelLancamentoCambio")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeRubricas() {
        return projetoServico
          .rubricasProjeto(this.filtros.idProjeto, this.filtros.idMetaEtapa)
          .then(rubricas => {
            this.rubricas = rubricas;
          });
      },
      listaDeSubrubricas() {
        this.filtros.idSubrubrica = '';
        
        return projetoServico
          .subrubricasProjeto(this.filtros.idProjeto, this.filtros.idRubrica)
          .then(subrubricas => {
            this.subrubricas = subrubricas;
          });
      },
      gerar() {
        this.relatorio = {};
        this.setarProjeto();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');

            return relatorioServico.lancamentosCambio(this.filtros)
          })
          .then(resultado => {
            this.relatorio = resultado.lancamentos;
            this.saldoAnterior = resultado.saldoAnterior;
            this.indice = resultado.indice || 0;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      saldoParcial(indice) {
        return this.saldoAnterior + this.relatorio.reduce((total, lancamento, index) => {
          if (index > indice) return total;

          if (lancamento.creditoDebito === 1) {
            return total + lancamento.valor;
          } else {
            return total - lancamento.valor;
          }
        }, 0);
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : null; 
      }
    },
    computed: {
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Lançamentos Financeiros/Câmbio`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();

      const _this = this;

      //$('.datepicker input').attr('readonly', '');

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
        
        _this.filtros.idRubrica = '';
        _this.filtros.idSubrubrica = '';
        
        _this.listaDeRubricas();
        _this.listaDeSubrubricas();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label">Período</label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto"
                        v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="rubrica">Rubrica</label>

                <select id="rubrica"
                        class="form-control"
                        v-model="filtros.idRubrica"
                        @change="listaDeSubrubricas">
                  <option value="">Selecione...</option>
                  <option :value="rubrica.id" v-for="rubrica in rubricas">{{ rubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label class="control-label" for="subrubrica">Subrubrica</label>

                <select id="subrubrica"
                        class="form-control"
                        v-model="filtros.idSubrubrica">
                  <option value="">Selecione...</option>
                  <option :value="subrubrica.id" v-for="subrubrica in subrubricas">{{ subrubrica.nome }}</option>
                </select>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button 
                id="gerar"
                type="button" 
                class="btn btn-primary" 
                @click="gerar"
                data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i> 
              Gerar relatório
            </button>

            <tela-cheia
              texto="Visualizar em tela cheia"
              icone="arrows-alt"
              v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio titulo="Relatório de Lançamentos Financeiros/Câmbio" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">

            <div class="table-responsive">
              <table class="table relatorio table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th class="text-right">Moeda</th>
                    <th class="text-right">Período</th>
                    <th class="text-right">Saldo anterior (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="no-border-right">{{ projeto.nomeProjeto}}</td>
                    <td class="text-right">{{ projeto.moeda }}</td>
                    <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
                    <td :class="['text-right no-border-left', saldoAnterior > 0 ? 'text-primary' : 'text-danger']">{{ saldoAnterior | formatarNumero }}</td>
                  </tr>
                </tbody>
              </table>
            
              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th>Data lanç.</th>
                    <th>Compens.</th>
                    <th>Documento</th>
                    <th>Rubrica</th>
                    <th>Histórico</th>
                    <th class="text-right">Valor (R$)</th>
                    <th class="text-right">Saldo parcial (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lancamento, index) in relatorio">
                    <td>{{ lancamento.data | formatarData }}</td>
                    <td>{{ lancamento.dataCompensacao | formatarData }}</td>
                    <td>{{ lancamento.documentoReceberPagar || '---' }}</td>
                    <td>{{ lancamento.nomeRubrica }}</td>
                    <td>{{ lancamento.historico }} - {{ lancamento.nomeSubrubrica }} - {{ lancamento.complemento }} | {{lancamento.idLancamento}}</td>
                    <td :class="['text-right', lancamento.creditoDebito === 1 ? 'text-primary' : 'text-danger']">{{ lancamento.creditoDebito === 1 ? '' : '-' }}{{ lancamento.valor | formatarNumero }}</td>
                    <td :class="['text-right', saldoParcial(index) > 0 ? 'text-primary' : 'text-danger']">{{ saldoParcial(index) | formatarNumero }}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="7" class="text-right">
                      <b>
                        Valor corrigido em reais: {{ (indice * saldoAnterior) | formatarNumero }}
                        Taxa {{ indice | formatarNumero(false,  true, 4) }} em {{ dataFim }}
                      </b>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/LancamentosCambio.vue